<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t("hotpicks") }}
    </h1>
    <!-- <select name="" id="" @change="fetchPageHotPicks($event)">
      <option value="">--Select View--</option>
      <option value="200">200</option>
      <option value="100">100</option>
      <option value="50">50</option>
      <option value="20">20</option>
      <option value="10">10</option>
      <option value="5">5</option>
    </select> -->
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md">
            <img class="mobiIcon" :src="HotPickIcon_prizeo" alt=""/>
            <span class="text_color">{{ $t("all") }} {{ $t("hotpicks") }} {{ getCategoryTranslate($route.query.q, lang_prizeo) }}</span>
          </h2>
        </div>
        <div v-if="isLoad === false">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>
        <div v-if="isLoad === true">
          <div class="mobiSection__content">
            <div class="row">
              <div  v-for="hot in getHotPicks()" :key="hot.key" :class="hot.class">
                <div v-if="$route.query.q === 'Video'">
                    <router-link class="browse_link mobiVideo mobiVideo--mrgn" :to="{name: 'DetailPage', params: { id: hot.content_id } }" >
                    <div class="mobiVideo__thumb">
                      <img class="img_wrp" :src="hot.cover_img" alt="" />
                    </div>
                    <div class="playBtn"><span></span></div>
                    <div class="mobiVideo__info">
                        <!-- <h3 class="mobiTitle sm">{{ hot.content_name }}</h3> -->
                        <span v-if="lang_prizeo !== 'english'">
                          <h3 class="mobiTitle sm" v-if="hot[`cont_name_${lang_prizeo}`] !== ''">{{ hot[`cont_name_${lang_prizeo}`] }}</h3>
                          <h3 class="mobiTitle sm" v-else>{{ hot[`cont_name_english`] }}</h3>
                        </span>
                        <span v-else>
                          <h3 class="mobiTitle sm">{{ hot[`cont_name_english`] }}</h3>
                        </span>
                      <div>
                          <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                          <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01" :show-rating="false" :border-width="2" border-color="#feb801" inactive-color="transparent" active-color="#ffb902" :rounded-corners= "false" :star-points="[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17]"
                          :rating="Number(hot.rating)"></star-rating>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div v-else>
                  <router-link class="browse_link mobiApp" :to="{
                    name: 'DetailPage',
                    params: { id: hot.content_id }
                    }">
                    <div v-if="hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game'" class="mobibadge badge--html5">
                      <img src="../../assets/prizeo/imgs/html5-badge.png"/>
                    </div>
                    <div class="mobiApp__thumb">
                      <img class="img_wrp" :src="hot.thumbnail_url" alt="" />
                    </div>
                    <div class="mobiApp__info">
                      <!-- <h3 class="mobiTitle sm text_color">{{hot.content_name}}</h3> -->
                      <span v-if="lang_prizeo !== 'english'">
                        <h3 class="mobiTitle sm text_color" v-if="hot[`cont_name_${lang_prizeo}`] !== ''">{{ hot[`cont_name_${lang_prizeo}`] }}</h3>
                        <h3 class="mobiTitle sm text_color" v-else>{{ hot[`cont_name_english`] }}</h3>
                      </span>
                      <span v-else>
                        <h3 class="mobiTitle sm text_color">{{ hot[`cont_name_english`] }}</h3>
                      </span>
                      <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                      <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01"  active-color="#ffb902" :show-rating="false" :border-width="3" border-color="#feb801" :rounded-corners="false" inactive-color="#fff" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :rating="Number(hot.rating)"></star-rating>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
export default {
  data() {
    return {
      query: "",
      isLoad: false
    };
  },
  components:{
    StarRating
  },
  computed: mapGetters(["pageHotPicks_prizeo", "HotPickIcon_prizeo", "lang_prizeo", "country_prizeo"]),
  props: ["browse"],
  created() {
    this.isLoad = false
    this.fetchPageHotPicks_prizeo([this.$route.query.q]);
    this.getHotPicks();
  },
  updated(){
    if(this.$route.query.q != this.query){
      this.isLoad = false
      this.fetchPageHotPicks_prizeo([this.$route.query.q]);
      this.getHotPicks()
      this.query = this.$route.query.q;
    }
  },
  methods: {
    ...mapActions(["fetchPageHotPicks_prizeo"]),
    getHotPicks() {
      let hotpick = [...this.pageHotPicks_prizeo];
      let hot = [];
      if (this.$route.query.q == undefined) {
        hotpick.map(item => {
          item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          hot.push(item);
        });
        setTimeout(() => {
          this.isLoad = true
        }, 2500);
        return hot;
      } else {
        hotpick.map(item => {
          if (this.$route.query.q == "Video") {
            //video
            item["class"] = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
          } else {
            item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
          }
          hot.push(item);
        });
        setTimeout(() => {
          this.isLoad = true
        }, 2500);
        return hot;
      }
    },
    getCategoryTranslate(q, lang) {
      let cat_translate = [];
      let hotpick = this.$props.browse.category;

      hotpick.map(item => {
        if (item.category == q) {
          if (lang != null) {
            cat_translate.push(item[`title_${lang}`]);
          } else {
            cat_translate.push(item[`title_english`]);
          }
        }
      });

      return cat_translate[0];
    }
  }
};
</script>

<style scoped>
.main_title {
  color: black;
}
.main_part div {
  display: inline-block;
  padding: 0 3px;
  color: black;
}
.browse_link {
  color: black;
}

.icon {
  height: 32px;
  width: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/prizeo/HotPicks.vue